import { render, staticRenderFns } from "./propertyList.vue?vue&type=template&id=7b814869&scoped=true&"
import script from "./propertyList.vue?vue&type=script&lang=js&"
export * from "./propertyList.vue?vue&type=script&lang=js&"
import style0 from "./propertyList.vue?vue&type=style&index=0&id=7b814869&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b814869",
  null
  
)

export default component.exports